<div id="customer-container" class="recipt-container card p-4 mt-4 mb-4">

    <div class="recipt-header">Welcome to {{this.companyName}}!</div>
    <div class="thank-you">
        <img src="assets/Icons/check-circle.svg" alt="checkmark" class="thank-you-icon">
        <div class="thank-you-text">Thank you for your payment!</div>
    </div>

    <hr>

    <div class="next-steps mb-2">
        <h5 class="next-steps-title">What Happens Next</h5>
        <div class="next-step">
            <div class="next-step-number">1</div>
            <div class="next-step-content">
                <div class="next-step-body">A <strong>payment confirmation email</strong> has been sent to <strong>{{this.emailProxy}}</strong> for your records.</div>
            </div>
        </div>
        <div class="next-step">
            <div class="next-step-number">2</div>
            <div class="next-step-content">
                <div class="next-step-body">You'll receive a separate <strong>enrollment email within 24 hours</strong> with instructions to create your online account and add the information you'd like to keep secure. <em>Be sure to check your spam folder if you don't see it.</em></div>
            </div>
        </div>
        <div class="next-step">
            <div class="next-step-number">3</div>
            <div class="next-step-content">
                <div class="next-step-body">An <strong>enrollment quick guide</strong> will be mailed to your address on file and should arrive within <strong>7 business days</strong>.</div>
            </div>
        </div>
    </div>

    <hr>

    <div class="customer-infoThank card p-4 mt-2 mb-4">

        <div class="row receipt-grid">
            <div class="col-md-6 receipt-cell">
                <div class="receipt-label">Account Holder</div>
                <div class="receipt-value" id="custName">{{this.customerName}}</div>
            </div>
            <div class="col-md-6 receipt-cell">
                <div class="receipt-label">Reference Number</div>
                <div class="receipt-value" id="pRef">{{this.purchaseRef}}</div>
            </div>
        </div>

        <div class="row receipt-grid">
            <div class="col-md-6 receipt-cell">
                <div class="receipt-label">Address</div>
                <div class="receipt-value">{{this.customer.address}}</div>
                <div class="receipt-value">{{this.customer.city}}, {{this.customer.state}} {{this.customer.zip}}</div>
            </div>
            <div class="col-md-6 receipt-cell">
                <div class="receipt-label">Email</div>
                <div class="receipt-value">{{this.customer.email}}</div>
            </div>
        </div>

        <div class="row receipt-grid">
            <div class="col-md-6 receipt-cell">
                <div class="receipt-label">Plan</div>
                <div class="receipt-value" id="planName">{{this.planName}}</div>
            </div>
            <div class="col-md-6 receipt-cell">
                <div class="receipt-label">Child Protection</div>
                <div class="receipt-value" id="childrenResponse">{{this.childrenResponse}}</div>
            </div>
        </div>

        <div class="row receipt-grid">
            <div class="col-md-6 receipt-cell">
                <div class="receipt-label">Payment Amount</div>
                <div class="receipt-value d-flex align-items-center gap-2 flex-wrap">
                    @if(this.discount > 0) {
                        <span class="text-muted text-decoration-line-through">{{this.subtotal | currency}}/mo</span>
                        <span id="paymentAmount">{{this.paymentAmount | currency}}/mo</span>
                        @if(this.couponCode) {
                            <span class="promo-badge">{{this.couponCode}}</span>
                        }
                    } @else {
                        <span id="paymentAmount">{{this.paymentAmount | currency}}/mo</span>
                    }
                </div>
            </div>
            <div class="col-md-6 receipt-cell">
                <div class="receipt-label">Payment Method</div>
                <div class="receipt-value" id="paymentMethod">{{this.paymentMethod}}</div>
            </div>
        </div>

        <div class="row receipt-grid">
            <div class="col-12 receipt-cell">
                <div class="receipt-label">Payment Date</div>
                <div class="receipt-value" id="paymentDate">{{this.paymentDate}}</div>
            </div>
        </div>

        <hr>
        <div class="recurring-notice">
            Recurring payments will be billed automatically to the card ending in {{this.customer.ccLast4}}.
            If you need to make changes to your payment, please call {{this.companyName}} Customer Service at
            <a href="tel:{{this.customerServicePhoneNumber}}">{{this.customerServicePhoneDisplay}}</a>.
        </div>

        <hr>
        <div class="text-center mt-2">
            <img src="assets/Icons/EXP-data-provided-by.svg" alt="Data provided by Experian" class="experian-icon">
        </div>
    </div>
</div>
